import { z } from 'zod';

export const resetPasswordDtoSchema = z.object({
  password: z.string().min(2),
  repeatPassword: z.string().min(2),
});

export type ResetPasswordDto = z.infer<typeof resetPasswordDtoSchema>;
